import React from 'react';
import { RouteComponentProps, Route, Switch } from 'react-router-dom';

import {
  CheckInPage,
  UserKeyPage,
  MyAccountPage,
  StayInfoPage,
  BulkReservationsChangeDatesPage,
  BulkReservationsCancelPage,
} from './pages';

export const ProfileRoutes: React.FC<RouteComponentProps> = ({ match }) => (
  <Switch>
    <Route exact path={`${match.path}`} component={MyAccountPage} />
    <Route exact path={`${match.path}/stays`} component={StayInfoPage} />
    <Route
      exact
      path={`${match.path}/bulk-change-dates`}
      component={BulkReservationsChangeDatesPage}
    />
    <Route exact path={`${match.path}/bulk-cancel`} component={BulkReservationsCancelPage} />
    <Route path={`${match.path}/stays/:reservationId/check-in`} component={CheckInPage} />
    <Route path={`${match.path}/key`} component={UserKeyPage} />
  </Switch>
);
